export const updateSearchTermsForUnmatchedCard = (card) => {
  let q = []
  if (card?.set) {
    q.push(card.set)
  } else if (card?.brand) {
    q.push(card.brand)
  }

  if (card?.subset) {
    q.push(card.subset)
  }

  if (card?.card_number) {
    q.push(`#${card.card_number}`)
  }

  if (card?.player) {
    q.push(card.player)
  }

  if (card?.attributes) {
    q.push(card.attributes)
  }

  return {
    searchTermForUnmatchedCard_: q.join(' '),
    searchTerms_: q.join(' ')
  }
}

export const getSearchTermForUnmatchedCard = (selectedCardData, listCard) => {
  if ((!selectedCardData?.matches || !selectedCardData.matches.length) && selectedCardData?.llm?.search_suggestion) {
    return selectedCardData.llm.search_suggestion
  }
  return updateSearchTermsForUnmatchedCard(listCard).searchTerms_
}

export const getLockSetQueryKey = (batchStore) => {
  let lockSetQueryKey = 'baseSetIds'

  if (batchStore.selectedBatch?.lock_id && batchStore.selectedBatch?.lock_includes_parallels) {
    lockSetQueryKey = 'baseSetIds'
  } else if (batchStore.selectedBatch?.lock_id && !batchStore.selectedBatch?.lock_includes_parallels) {
    lockSetQueryKey = 'setIds'
  }

  return lockSetQueryKey
}

/**
 * Build the options object for `searchStore.searchDatabaseMatches`. Single
 * source shared by the desktop DatabaseMatchField and the mobile search modal
 * so the query contract can never drift between the two surfaces.
 *
 * @param {string} query — the raw search term.
 * @param {Object} batchStore — carries `selectedBatch.type` + `selectedBatch.locked_sets`.
 * @param {Object} [extra] — extra keys to merge (e.g. `{ page }` for load-more).
 */
export const buildDatabaseSearchOptions = (query, batchStore, extra = {}) => {
  const options = { query, kind: batchStore?.selectedBatch?.type, ...extra }
  const params = getParamsBasedOnLockedSets(batchStore?.selectedBatch?.locked_sets)
  if (params.baseSetIds) options.baseSetIds = params.baseSetIds
  if (params.setIds) options.setIds = params.setIds
  return options
}

export const getParamsBasedOnLockedSets = (lockedSets = []) => {
  let baseSetIds = ''
  let setIds = ''

  lockedSets?.forEach((item) => {
    if (item.include_parallels) {
      if (baseSetIds) {
        baseSetIds = `${baseSetIds},${item.collx_set_id}`
      } else {
        baseSetIds = `${item.collx_set_id}`
      }
    } else {
      if (setIds) {
        setIds = `${setIds},${item.collx_set_id}`
      } else {
        setIds = `${item.collx_set_id}`
      }
    }
  })

  const params = {}

  if (baseSetIds) {
    params['baseSetIds'] = baseSetIds
  } 

  if (setIds) {
    params['setIds'] = setIds
  }

  return params
}